export function setDeviceFlowCodeCookie(token: string, expires: string) {
    document.cookie = `device_flow_code_response=${token}; expires=${expires} UTC; path=/; SameSite=Strict; Secure`
}
